module.exports = __webpack_public_path__ + "static/media/info-circle-blue.b9edc1ba.svg";